// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=file] {
  width: 0;
  height: 1px;
}

.existing-files {
  overflow: auto;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.existing-files .no-results {
  font-size: 0.9em;
  margin-top: 10px;
}

.filebox {
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: 90px;
  height: 90px;
  background: #fff;
  border: solid 1px #ccc;
  border-radius: 5px;
  margin: 5px 5px 5px 0;
}
.filebox .file-icon {
  font-size: 2em;
  color: #eee;
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  text-align: center;
}
.filebox .download-icon, .filebox .remove-icon, .filebox .select-icon {
  font-size: 1.3em;
  color: #fff;
  position: absolute;
  top: 5px;
  right: 5px;
}
.filebox .download-icon {
  left: 5px;
  right: auto;
}
.filebox .filename {
  position: absolute;
  font-size: 0.8em;
  line-height: 1.1em;
  bottom: 5px;
  left: 5px;
  right: 5px;
  max-height: 56px;
  overflow: hidden;
  white-space: pre-wrap; /* CSS3 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* Opera <7 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* IE */
}
.filebox:hover {
  background: #ddd;
}

.upload-indicator {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 255, 0, 0.2);
}

.dropzone {
  background: #fff;
  border: dotted 2px #ccc;
  border-radius: 5px;
  text-align: center;
  padding: 30px 0;
  margin: 15px 0;
}
.dropzone small {
  pointer-events: none;
}
.dropzone form-button.secondary button {
  margin-top: 8px;
  padding-left: 0;
  padding-right: 0;
}
.dropzone form-button.secondary button label {
  padding: 14px 25px 14px 15px;
  cursor: pointer;
}
.dropzone label form-button span {
  padding: 14px 25px 14px 15px;
}
.dropzone.dragover {
  background: #efefef;
}
.dropzone.dragover form-button {
  pointer-events: none;
}
.dropzone.dragover form-button button {
  background: #efefef;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/resources/elements/form-input-file/form-input-file.scss"],"names":[],"mappings":"AAAA;EACI,QAAA;EACA,WAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AACJ;AACI;EACI,gBAAA;EACA,gBAAA;AACR;;AAGA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;AAAJ;AAEI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AAAR;AAGI;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AADR;AAII;EACI,SAAA;EACA,WAAA;AAFR;AAKI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA,EAAA,SAAA;EACA,0BAAA,EAAA,YAAA;EACA,sBAAA,EAAA,aAAA;EACA,wBAAA,EAAA,YAAA;EACA,qBAAA,EAAA,OAAA;AAHR;AAMI;EACI,gBAAA;AAJR;;AAQA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,gCAAA;AALJ;;AAQA;EACI,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AALJ;AAOI;EACI,oBAAA;AALR;AAQI;EACI,eAAA;EACA,eAAA;EACA,gBAAA;AANR;AAQQ;EACI,4BAAA;EACA,eAAA;AANZ;AAYY;EACI,4BAAA;AAVhB;AAeI;EACI,mBAAA;AAbR;AAeQ;EACI,oBAAA;AAbZ;AAeY;EACI,mBAAA;EACA,YAAA;AAbhB","sourcesContent":["input[type=\"file\"] {\n    width: 0;\n    height: 1px;\n}\n\n.existing-files {\n    overflow: auto;\n    overflow-y: hidden;\n    overflow-x: auto;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n\n    .no-results {\n        font-size: 0.9em;\n        margin-top: 10px;\n    }\n}\n\n.filebox {\n    cursor: pointer;\n    display: inline-block;\n    position: relative;\n    width: 90px;\n    height: 90px;\n    background: #fff;\n    border: solid 1px #ccc;\n    border-radius: 5px;\n    margin: 5px 5px 5px 0;\n\n    .file-icon {\n        font-size: 2em;\n        color: #eee;\n        position: absolute;\n        top: 25px;\n        left: 0;\n        right: 0;\n        text-align: center;\n    }\n\n    .download-icon, .remove-icon, .select-icon {\n        font-size: 1.3em;\n        color: #fff;\n        position: absolute;\n        top: 5px;\n        right: 5px;\n    }\n\n    .download-icon {\n        left: 5px;\n        right: auto;\n    }\n\n    .filename {\n        position: absolute;\n        font-size: 0.8em;\n        line-height: 1.1em;\n        bottom: 5px;\n        left: 5px;\n        right: 5px;\n        max-height: 56px;\n        overflow: hidden;\n        white-space: pre-wrap;      /* CSS3 */\n        white-space: -moz-pre-wrap; /* Firefox */\n        white-space: -pre-wrap;     /* Opera <7 */\n        white-space: -o-pre-wrap;   /* Opera 7 */\n        word-wrap: break-word;      /* IE */\n    }\n\n    &:hover {\n        background: #ddd;\n    }\n}\n\n.upload-indicator {\n    position: absolute;\n    top:0;\n    bottom:0;\n    left:0;\n    background: rgba(0,255,0,0.2);\n}\n\n.dropzone {\n    background: #fff;\n    border: dotted 2px #ccc;\n    border-radius: 5px;\n    text-align: center;\n    padding: 30px 0;\n    margin: 15px 0;\n\n    small {\n        pointer-events: none;\n    }\n\n    form-button.secondary button {\n        margin-top: 8px;\n        padding-left: 0;\n        padding-right: 0;\n        \n        label {\n            padding: 14px 25px 14px 15px;\n            cursor: pointer;\n        }\n    }\n\n    label {\n        form-button {\n            span {\n                padding: 14px 25px 14px 15px;\n            }\n        }\n    }\n\n    &.dragover {\n        background: #efefef;\n\n        form-button {\n            pointer-events: none;\n\n            button {\n                background: #efefef;\n                opacity: 0.5;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
